import { h, Component } from 'preact';
import HTML from 'components/core/html/html';
// import Close from 'components/bolt/icons/close';
import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import Button from 'components/bolt/button/button';
import { joinClasses } from 'utils/utils';
import Store from 'store/store';
import s from 'components/bolt/hub/components/hubTextOverlay/hubTextOverlay.sss';

export default class HubTextOverlay extends Component {
	componentDidUpdate(prevProps) {
		if (prevProps.show !== this.props.show) {
			Store.emit('HUB_TEXT_OVERLAY_SHOW', this.props.show);
		}
	}

	state = { isClosing: false };

	handleClose = (closeOverlay) => {
		this.setState({ isClosing: true });
		setTimeout(() => {
			this.setState({ isClosing: false });
			closeOverlay();
		}, 100);
	};

	render({ content, show, closeOverlay }) {
		return (
			<div class={joinClasses(s.container, (show || this.state.isClosing) && s.show)}>
				<div 
					class={s.bgGradient} 
					onClick={() => this.handleClose(closeOverlay)} 
				/>
				<Button
					class={s.closeTextOverlayButton}
					trigger={() => this.handleClose(closeOverlay)}
				>
					<BurgerMenu
						type={show && !this.state.isClosing ? 'close' : 'burger'}
						hubTextOverlayOpen
					/>
				</Button>
				<div class={s.bgGradient} onClick={closeOverlay} />
				<HTML
					class={s.content}
					markdown
					content={content}
				/>
				{/* <button class={s.closeBtn} onClick={closeOverlay}>
					<Close class={s.close} />
				</button> */}
			</div>
		);
	}
}